import React, { useState, useEffect } from 'react';
import { Layout, Avatar, Button, Typography, Space, message, Menu, Drawer, Grid } from 'antd';
import {
    UserOutlined,
    LogoutOutlined,
    FileTextOutlined,
    ClockCircleOutlined,
    TeamOutlined,
    CheckCircleOutlined,
    MenuOutlined,
    ToolOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const Home = () => {
    const [userInfo, setUserInfo] = useState({});
    const [drawerVisible, setDrawerVisible] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const selectedMenu = location.pathname.split('/')[2] || 'giao-viec';

    useEffect(() => {
        // Lấy thông tin user từ localStorage
        const username = localStorage.getItem('username');
        const job = localStorage.getItem('job');
        const avatar = localStorage.getItem('avatar');
        const role = localStorage.getItem('role');
        const userID = localStorage.getItem('userID');

        if (!username) {
            message.error('Vui lòng đăng nhập!');
            navigate('/login');
            return;
        }

        setUserInfo({
            username,
            job,
            avatar,
            role,
            userID
        });
    }, [navigate]);

    const handleLogout = () => {
        // Xóa tất cả thông tin trong localStorage
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userID');
        localStorage.removeItem('username');
        localStorage.removeItem('job');
        localStorage.removeItem('avatar');
        localStorage.removeItem('role');

        message.success('Đăng xuất thành công!');
        navigate('/login');
    };

    const menuItems = [
        {
            key: 'giao-viec',
            icon: <FileTextOutlined />,
            label: 'Giao việc',
        },
        {
            key: 'viec-dang-lam',
            icon: <ClockCircleOutlined />,
            label: 'Việc đang làm',
        },
        {
            key: 'lich-su-doi',
            icon: <TeamOutlined />,
            label: 'Lịch sử đội',
        },
        {
            key: 'thanh-vien-diem-danh',
            icon: <CheckCircleOutlined />,
            label: 'Thành viên điểm danh',
        },
        {
            key: 'reset-status',
            icon: <ToolOutlined />,
            label: 'Reset trạng thái',
        },
    ];

    const sidebarContent = (
        <div style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: 'linear-gradient(180deg, #115E59 0%, #0F766E 45%, #0D9488 100%)'
        }}>
            <div style={{
                padding: '28px 20px 22px',
                textAlign: 'center',
                borderBottom: '1px solid rgba(255,255,255,0.14)'
            }}>
                <Avatar
                    size={68}
                    src={userInfo.avatar}
                    icon={<UserOutlined />}
                    style={{ marginBottom: '12px', border: '3px solid rgba(255,255,255,0.4)' }}
                />
                <div>
                    <Text strong style={{ display: 'block', fontSize: '15px', color: '#fff' }}>{userInfo.username}</Text>
                    <Text style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)' }}>{userInfo.job}</Text>
                </div>
            </div>

            <div style={{
                padding: '18px 24px 6px',
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                color: 'rgba(255,255,255,0.45)',
                textTransform: 'uppercase'
            }}>
                Chức năng
            </div>

            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[selectedMenu]}
                items={menuItems}
                onClick={(e) => {
                    navigate(`/home/${e.key}`);
                    if (isMobile) setDrawerVisible(false);
                }}
                style={{ background: 'transparent', border: 'none', padding: '4px 12px', flex: 1 }}
            />
        </div>
    );

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header style={{
                background: 'linear-gradient(135deg, #0F766E 0%, #0D9488 55%, #14B8A6 100%)',
                padding: '0 20px',
                boxShadow: '0 2px 12px rgba(15, 118, 110, 0.25)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'fixed',
                width: '100%',
                zIndex: 1000
            }}>
                <Space size="small">
                    {isMobile && (
                        <Button
                            icon={<MenuOutlined />}
                            onClick={() => setDrawerVisible(true)}
                            type="text"
                            size="large"
                            style={{ color: '#fff' }}
                        />
                    )}
                    <Title
                        level={isMobile ? 5 : 3}
                        style={{ margin: 0, color: '#fff', whiteSpace: 'nowrap', fontWeight: 700 }}
                    >
                        {isMobile ? 'GV NLTECH' : 'Giao Việc NLTECH'}
                    </Title>
                </Space>

                <Space size="middle">
                    <Space size="small">
                        <Avatar
                            size={isMobile ? 'default' : 'large'}
                            src={userInfo.avatar}
                            icon={<UserOutlined />}
                            style={{ border: '2px solid rgba(255,255,255,0.6)' }}
                        />
                        {!isMobile && <Text strong style={{ color: '#fff' }}>{userInfo.username}</Text>}
                    </Space>
                    <Button
                        type="primary"
                        danger
                        icon={<LogoutOutlined />}
                        onClick={handleLogout}
                        size={isMobile ? 'small' : 'middle'}
                    >
                        {!isMobile && 'Đăng xuất'}
                    </Button>
                </Space>
            </Header>

            <Layout style={{ marginTop: '64px' }}>
                {!isMobile && (
                    <Sider
                        width={260}
                        style={{
                            position: 'fixed',
                            height: 'calc(100vh - 64px)',
                            left: 0,
                            top: '64px',
                            overflowY: 'auto',
                            boxShadow: '2px 0 16px rgba(15, 118, 110, 0.18)'
                        }}
                    >
                        {sidebarContent}
                    </Sider>
                )}

                <Drawer
                    title={<span style={{ color: '#fff', fontWeight: 700 }}>Menu</span>}
                    placement="left"
                    onClose={() => setDrawerVisible(false)}
                    open={drawerVisible}
                    width={260}
                    closeIcon={<CloseOutlined style={{ color: '#fff' }} />}
                    styles={{
                        body: { padding: 0 },
                        header: {
                            background: 'linear-gradient(135deg, #0F766E 0%, #0D9488 100%)',
                            borderBottom: 'none'
                        },
                        content: { padding: 0 }
                    }}
                >
                    {sidebarContent}
                </Drawer>

                <Layout style={{ marginLeft: isMobile ? 0 : '260px' }}>
                    <Content style={{
                        padding: '0px',
                        background: '#f5f7fa',
                        minHeight: 'calc(100vh - 64px)'
                    }}>
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default Home;
